import { render, staticRenderFns } from "./OneOrder.vue?vue&type=template&id=6e966314&scoped=true&"
import script from "./OneOrder.vue?vue&type=script&lang=js&"
export * from "./OneOrder.vue?vue&type=script&lang=js&"
import style0 from "./OneOrder.vue?vue&type=style&index=0&id=6e966314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e966314",
  null
  
)

export default component.exports